$('body').on('click', function (e) {
    if (!$(e.target).closest('.user').length) {
    $('.user .popover').each(function () {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $('.popover').removeClass('show');
        }
    });
}
});